import { snackbarProgrammatic } from '@/components/snackbar/index';
import router from '@/router';
import { DataImportFileStatusUpdated } from '@/shared/events/data-import-file-status-updated';
import { User } from '@/shared/user';
import store from '@/store';

async function handleDataImportFileStatusUpdated(data: DataImportFileStatusUpdated): Promise<void> {
    const currentUser: User | null = store.getters['user/user'];

    if (currentUser == null) {
        return;
    }

    if (currentUser.id === data.userId) {
        if (data.status === 'InProgress') {
            snackbarProgrammatic.open({ message: `Data import file '${data.filename}' in progress.`, type: 'is-warning' });
        } else if (data.status === 'Failed') {
            snackbarProgrammatic.open({ message: `Data import file '${data.filename}' failed.`, type: 'is-danger' });
        } else if (data.status === 'Succeeded') {
            snackbarProgrammatic.open({ message: `Data import file '${data.filename}' succeeded.`, type: 'is-success' });
        }
    }

    if (router.currentRoute.name !== 'data-import') {
        return;
    }

    await store.dispatch(`import/loadDataImportFilesAsync`);
}

export default handleDataImportFileStatusUpdated;
